var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.366821 13.1363V0.704346L1.28394 1.51955L2.22653 0.704346L3.16911 1.51955L4.11169 0.704346L5.05428 1.51955L5.99687 0.704346L6.93946 1.51955L7.88205 0.704346L8.82464 1.51955L9.76721 0.704346L10.7098 1.51955L11.6269 0.704346V13.1363L10.7098 12.3211L9.76721 13.1363L8.82464 12.3211L7.88205 13.1363L6.93946 12.3211L5.99687 13.1363L5.05428 12.3211L4.11169 13.1363L3.16911 12.3211L2.22653 13.1363L1.28394 12.3211L0.366821 13.1363ZM2.18831 9.86271H9.80543V8.86919H2.18831V9.86271ZM2.18831 7.41708H9.80543V6.42357H2.18831V7.41708ZM2.18831 4.97146H9.80543V3.97793H2.18831V4.97146ZM1.36035 11.6231H10.6334V2.21756H1.36035V11.6231Z",
    fill: "#FFC222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.9ca1fd85ff6afad5d3978352f2c491c0.svg";
export { ForwardRef as ReactComponent };